import { createSharedComposable } from '@vueuse/core';
import { computed } from 'vue';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { useUserPermission } from './user/use-user-permission';
import { useUserInfo } from './user/use-user-info';
const MAX_COMPANY_NAME_LENGTH = 3;
export const useUploadPermission = createSharedComposable(() => {
    const { userPermission } = useUserPermission();
    const { userInfo } = useUserInfo();
    const i18n = injectService(i18nSymbol);
    const _ipUploadDisabled = computed(() => {
        return !userPermission.value.enable_ip_upload;
    });
    const _userUploadDisabled = computed(() => {
        return !userPermission.value.enable_upload;
    });
    const enableUpload = computed(() => {
        return userPermission.value.enable_upload && userPermission.value.enable_ip_upload;
    });
    // 以图搜图功能需要拥有功能权限和上传权限
    const enableImageDiscovery = computed(() => {
        return userPermission.value.enable_image_discovery && enableUpload.value;
    });
    const ipUploadDisabledCompanyNames = computed(() => {
        const companyNames = userInfo.value.ip_upload_disabled_company_names || [];
        return companyNames.length <= MAX_COMPANY_NAME_LENGTH ?
            companyNames.join(',') : `${companyNames.slice(0, MAX_COMPANY_NAME_LENGTH).join(',')}...`;
    });
    const uploadDisabledTips = computed(() => {
        if (_ipUploadDisabled.value) {
            return i18n.t('taskBox.ipLoadDisabled', { name: ipUploadDisabledCompanyNames.value });
        }
        if (_userUploadDisabled.value) {
            return i18n.t('taskBox.uploadDisabled');
        }
        return '';
    });
    return {
        enableImageDiscovery,
        enableUpload,
        uploadDisabledTips,
    };
});
